export default "/images/vendor/flag-icons/flags/4x3/jp.svg?d288d548026f04523965869470b09fc5";